class SampleButton extends HTMLElement {
    // Classes
    static addButton = 'sample-button';

    // Defaults
    static addedIcon = `<img src="${window.ShopifyAssets.added.url}" height="${window.ShopifyAssets.added.height}" width="${window.ShopifyAssets.added.width}" /> added`;
    static addingIcon = `<img src="${window.ShopifyAssets.adding.url}" height="${window.ShopifyAssets.adding.height}" width="${window.ShopifyAssets.adding.width}" />`;

    constructor() {
        super();

        this.addSampleToCartButton = this.querySelector(`.${SampleButton.addButton}`);
        this.addSampleToCartButton.addEventListener('click', this.addSampleToCart.bind(this));

        this.buttonText = this.addSampleToCartButton.innerText;
        this.productType = this.addSampleToCartButton.getAttribute('data-product-type');
        this.sampleHandle = this.addSampleToCartButton.getAttribute('data-sample-handle');
    }

    async fetchProductByHandle() {
        const response = await fetch(`/products/${this.sampleHandle}.json`);

        if (!response.ok)
            throw new Error(`Failed to fetch product with handle: ${this.sampleHandle}. Status: ${response.status} ${response.statusText}`);

        const data = await response.json();

        return data.product;
    }

    async fetchCart() {
        const response = await fetch(`${window.Shopify.routes.root}cart.js`);

        if (!response.ok)
            throw new Error(`Failed to fetch cart. Status: ${response.status} ${response.statusText}`);

        const data = await response.json();

        return data.items;
    }

    async addToCart(variantId) {
        let item = {
            'id': variantId,
            'quantity': 1
        };

        let properties = {};
        if (this.productType)
            properties['_sample'] = this.productType.replace(/\n/g, "\\n");

        if (Object.keys(properties).length)
            item['properties'] = properties;

        const payload = {
            'items': [item]
        };

        const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(payload)
        });

        if (!response.ok)
            throw new Error(`Failed to add product with ID: ${variantId} to cart. Status: ${response.status} ${response.statusText}`);

        return await response.json();
    }

    refreshCartIcon() {
        fetch(window.location.href)
            .then(response => response.text())
            .then(html => {
                const parser = new DOMParser();
                const doc = parser.parseFromString(html, 'text/html');
                const newCartCount = doc.querySelector('.CartCount');

                if (newCartCount) {
                    const currentCartCount = document.querySelector('.CartCount');
                    currentCartCount.innerHTML = newCartCount.innerHTML;
                }
            })
            .catch(error => {
                console.error('Error loading the CartCount:', error);
            });
    }

    async addSampleToCart(event) {
        event.preventDefault();
        
        this.addSampleToCartButton.classList.add('adding-to-cart');
        this.addSampleToCartButton.innerHTML = SampleButton.addingIcon;

        let errorOccurred = false;

        try {
            const product = await this.fetchProductByHandle();

            if (product && product.variants && product.variants.length > 0) {
                const variant = product.variants[0];

                if (variant.price <= 0) {
                    const cartItems = await this.fetchCart();

                    if (cartItems.some(item => item.id === variant.id)) {
                        alert('The maximum amount of this sample has already been added to your bag.');
                        throw new Error('The variant is already present in the cart.');
                    }
                }

                const cart = await this.addToCart(variant.id);
                // console.log('Product successfully added to cart!', cart);
            } else {
                throw new Error("The product doesn't have any variants to add to the cart.");
            }
        } catch (error) {
            // console.error('Error while adding sample to cart:', error);
            errorOccurred = true;
        } finally {
            this.addSampleToCartButton.classList.remove('adding-to-cart');

            if (errorOccurred) {
                this.addSampleToCartButton.innerText = this.buttonText;
            } else {
                this.refreshCartIcon();

                this.addSampleToCartButton.classList.add('added-to-cart');
                this.addSampleToCartButton.innerHTML = SampleButton.addedIcon;

                setTimeout(() => {
                    this.addSampleToCartButton.classList.remove('added-to-cart');
                    this.addSampleToCartButton.innerText = this.buttonText;
                }, 2000);
            }
        }
    }
}

customElements.define('sample-button', SampleButton);